import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import HttpWriterForm from '../forms/http-writer-form';
import { httpWriterValidationSchema } from '../schema/httpWriter.js';

export default function HttpWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'HTTP Writer Node Details',
        altText: 'HTTP Writer Node',
        defaultLabel: 'HTTP Writer Node',
      }}
    >
      <CommonNode FormComponent={HttpWriterForm} schemaResolver={httpWriterValidationSchema} />
    </NodeProvider>
  );
}
